import { render, staticRenderFns } from "./ContactLayoutCustomFieldDisplay.vue?vue&type=template&id=5763572e&scoped=true"
import script from "./ContactLayoutCustomFieldDisplay.vue?vue&type=script&lang=js"
export * from "./ContactLayoutCustomFieldDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763572e",
  null
  
)

export default component.exports